/*
 * @Description: 自动更新
 */
const timeData = 10 * 1000; // 检查间隔时间
let hidden = false; // 页面是否隐藏
let setTimeoutId;

const getVersion = async () => {
  // 获取版本号
  const timestamp = new Date().getTime();
  return fetch(`/version.json?timestamp=${timestamp}`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
    },
    cache: "no-store",
  })
    .then((res) => {
      return res.json();
    })
};
// 检查更新
const checkUpdate = async () => {
  const version = (await getVersion())?.version;
  if (!localStorage.getItem("v3_version")) {
    localStorage.setItem("v3_version", version);
  } else {
    if (version != localStorage.getItem("v3_version")) {
      localStorage.setItem("v3_version", version);
      location.reload(); // 刷新当前页
    }
  }
};

// 自动更新
const autoUpdate = async () => {
  setTimeoutId = setTimeout(async () => {
    // 页面隐藏了就不检查更新
    if (!hidden) {
      checkUpdate();
    }
    autoUpdate();
  }, timeData);
};

// 停止检测更新
const stop = () => {
  if (setTimeoutId) {
    clearTimeout(setTimeoutId);
    setTimeoutId = "";
  }
};

// 开始检查更新
const start = async () => {
  checkUpdate();
};

export default { start };
